import type { PortfolioDetailResponseDTO } from "web_myplann/Infrastructure/Api/Api";
import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";
import { BuildingSavingsFormFields } from "web_myplann/Portfolio/Forms/BuildingSavingsForm/BuildingSavingsFormFields";
import { useEditBuildingSavingsForm } from "web_myplann/Portfolio/Forms/BuildingSavingsForm/useEditBuildingSavingsForm";
import { PortfolioFormShell } from "web_myplann/Portfolio/PortfolioShared/PortfolioFormShell";

type EditBuildingSavingsFormProps = {
	portfolioId: number;
	portfolio: PortfolioDetailResponseDTO;
	detailRoute: string;
};

export const EditBuildingSavingsForm = ({
	portfolioId,
	portfolio,
	detailRoute,
}: EditBuildingSavingsFormProps) => {
	const { t } = useResource();
	const { form, onSubmit, isPending, leaveConfirmation } =
		useEditBuildingSavingsForm({
			portfolioId,
			portfolio,
			detailRoute,
		});

	return (
		<PortfolioFormShell
			onSubmit={onSubmit}
			submitLabel={t(Resources.Portfolio.EditPortfolio.submit)}
			disabled={!form.formState.isDirty}
			loading={isPending}
			leaveConfirmation={leaveConfirmation}
		>
			<BuildingSavingsFormFields
				control={form.control}
				disableKeyFields={!portfolio.allowKeyPropertiesEditByClient}
			/>
		</PortfolioFormShell>
	);
};
